<template>
	<div  class="app_box">
		<!--<van-nav-bar
      title="新增"
      left-text=""
      right-text=""
    />-->
		<div class="content">
			<div class="top_img">
				<img src="../assets/c.jpg"/>
			</div>
			<!--<p class="tl">
				<a href="">2021年，是中国共产党百年华诞。在100年波澜壮阔的历史进程中，中国共产党团结带领人民不忘初心、牢记使命、艰苦奋斗，战胜了一个又一个困难，取得一个又一个胜利。为回顾和展现中国共产党百年光辉历程，生动展现江淮大地发生的喜人变化，抒发广大党员干部群众浓浓的家国情怀，现面向社会，开展“美好生活 百年印记”安徽省庆祝建党100周年原创精品短视频征集展示活动。</a>
			</p>-->
		</div>

		<van-form @submit="onSubmit" rel="form">
			
			<van-field v-model="title" name="title" label="标题" placeholder="" :rules="[{ required: true, message: '请输入标题' }]" />
			<van-field v-model="content" rows="8" name="content" autosize label="内容简介" type="textarea" placeholder="" :rules="[{ required: true, message: '请输入内容简介' }]" />

			<van-field v-model="nickname" name="nickname" label="姓名" placeholder="" :rules="[{ required: true, message: '请输入姓名' }]" />

			<van-field v-model="contact" name="contact" label="联系方式" placeholder="" :rules="[{ required: true, message: '请输入联系方式' }]" />

			
			<!--<van-field name="is_show" label="是否公开">
				<template #input>
				<van-radio-group v-model="is_show" direction="horizontal">
					<van-radio name="1">公开</van-radio>
					<van-radio name="0">私有</van-radio>
				</van-radio-group>
				</template>
			</van-field>-->


			<div class="van-cell van-field">
				<van-uploader name="files[]" id="file_upload1" accept="image/*, video/*" upload-icon="vvan-icon van-icon-video-o van-uploader__upload-icon" upload-text="图片和附件" :after-read="afterRead" v-model="fileList" multiple />
				
			</div>
			<!--<p class="msg">视频限制500M以内，若视频上传失败请发送至邮箱anhuinewsvedio@163.com。需留下内容简介和个人联系方式。</p>-->

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>

	</div>

</template>
<style>
	body,
	#app {
		max-width: 1080px;
		margin: 0px auto;
		background: white;
		width:100%;
	}
	
	.app_box {
		max-width: 1080px;
		margin: 0px auto;
	}
	
	.content {
		background: white;
	}
	
	.content p {
		padding: 0px;
		margin: 0px;
	}
	
	.content p.tl {
		width: 96%;
		margin: 0px auto;
		font-size: 14px;
		text-indent: 2em;
		padding: 20px 0px;
		line-height: 24px;
	}
	
	.content p.tl a {
		color: #232323;
	}
	
	.top_img {
		width: 100%;
		margin-bottom:3%
	}
	
	.top_img img {
		display: block;
		width: 100%;
	}
	 .van-cell::after{
		border-bottom:1px solid #bcbcbc !important;
		border: none !important;
	}
	#app .van-cell input{
		border:1px solid #E8E8E8 !important;
		padding:4px 0px;
	}	
	textarea.van-field__control{
		height:100px !important;
		border:1px solid #E8E8E8 !important;
		padding:4px 0px;
	}
	.van-field__label{
		width:4.2rem !important;
	}
	.msg{
		color: #ee0a24;
		font-size: 12px;
		text-align: left;
		padding: 10px 16px;
		margin:0px;
	}
	
</style>

<script>
	import { upload, add } from '@/api/app'
	export default {
		data() {
			return {
				activeNames: ['1'],
				list: [],
				title: '',
				content: '',
				nickname:'',
				contact:'',
				type: '3',
				file: [],
				types: [],
				fileList:[]
				//radio: '3'
			}
		},
		components: {

		},
		computed: {},
		mounted() {},
		created() {},

		methods: {
			onSubmit(e) {
				let ids = [];
				//if(this.fileList.length == 0) {
					//this.$toast('请上传视频')
				//	return false
			//	}
				for(let i in this.fileList) {
					/*返回参数*/
					console.log(e)
					if(i == 0) e.attachment_id = this.fileList[i]['info']

					ids.push((this.fileList[i]['info'])[0])
					
				}
				e.file = ids
				let _this = this
				e.type = '涉未成年人投诉举报'
				add(e).then(res => {
					this.$toast.success('提交成功')
				})
			},
			afterRead(file) {
				file.status = 'uploading';
				file.message = '上传中...';
				upload(file.file).then(res => {
					file.status = 'done'
					file.info = res
					this.$toast('上传成功')
				})
			},
			JumpUrl(row) {
				this.$router.push({
					name: 'Index'
				})
			}
		}
	};
</script>